import { Flex } from '@chakra-ui/react';
import { useListingPageContext } from '../../ListingPageContext';
import { OfferScorecardButton, ShareWithClientButton } from '../Buttons';

export const ListingPageMobileActionBar = () => {
  const { isViewOnly, isOffMarketListing } = useListingPageContext();

  if (isViewOnly || isOffMarketListing) {
    return null;
  }

  return (
    <Flex
      bg="bg.main"
      borderColor="border.divider"
      borderTopWidth="1px"
      bottom={0}
      gap={2}
      justifyContent="center"
      p={4}
      position="sticky"
      width="100%"
      zIndex={2}
    >
      <ShareWithClientButton />
      <OfferScorecardButton />
    </Flex>
  );
};
